import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ImprovementActivityApiModel, ImprovementPlanListDeleteResultApiModel } from '@app/api/api-models';
import { CrudService } from '@app/api/api-services/crud.service';

@Injectable()
export class ImprovementActivitiesService extends CrudService<ImprovementActivityApiModel, number> {
  public readonly apiUrl = 'improvement-activities';

  public deleteWithGuard(id: number): Observable<ImprovementPlanListDeleteResultApiModel> {
    return this.http.delete<ImprovementPlanListDeleteResultApiModel>(`${this.apiUrl}/delete/${id}`);
  }
}
